import Register from './register'
/*
  업무용 로컬 상태 관리
*/

const init = () => {
  // Custom store 용 Map 정의

  if (window.vue.getStoreMap() === undefined) {
    console.info('initSystemStore()')
    var localMap = new Map()
    window.vue.setStoreMap(localMap)

    // Custom store 추가
    var list = Register.register()
    for (var index = 0; index < list.length; index++) {
      let customSotre = list[index]

      let localInstance = customSotre.createInstance()

      localMap.set(customSotre.getName(), localInstance)
    }
  }
}

var customStore = {}
customStore.init = init

export default customStore



// WEBPACK FOOTER //
// ./src/_fdp/core/vuex/system/index.js